import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './pages/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  role?: 'admin' | 'user' | 'employee' | 'instructor'  | 'any';
}

const ProtectedRoute = ({ children, role = 'any' }: ProtectedRouteProps) => {
  const { isAdmin, isUser,isEmployee,isInstructor, loading } = useAuth();

  if (loading) {
    return <div style={{ textAlign: 'center', marginTop: '50px' }}>Loading...</div>;
  }

  if (role === 'admin' && !isAdmin) return <Navigate to="/login" replace />;
  if (role === 'user' && !isUser) return <Navigate to="/login" replace />;
   if (role === 'employee' && !isEmployee) return <Navigate to="/login" replace />;
  if (role === 'instructor' && !isInstructor) return <Navigate to="/login" replace />;

if (role === 'any' && !(isAdmin || isUser || isEmployee || isInstructor)) {
  return <Navigate to="/login" replace />;
}

  return <>{children}</>;
};

export default ProtectedRoute;
